export const translations = {
  'da-DK': {
    translation: {
      addUser: 'Tilføj bruger',
      editUser: 'Rediger bruger',
      firstName: 'Fornavn',
      lastName: 'Efternavn',
      name: 'Navn',
      role: 'Rolle',
      status: 'Status',
      email: 'E-mail',
      phone: 'telefon',
      type: 'Type',
      details: 'Detaljer',
      nodes: 'Noder',
      roles: 'Roller',
      cancel: 'Annuller',
      submit: 'send',
      delete: 'Slet',
      create: 'Opret',
      deleteNodeError: 'Fejl ved sletning af node',
      deleteConfirmation: 'Er du sikker på, at du vil slette?',
      warning: 'Advarsel',
      Alert: 'Alarm',
      deleteSure: 'Ja, jeg er sikker',
      nodesWillBeCreatedAt: 'Noder oprettes på',
      searchFor: 'Søg efter',
      rolesError: 'Fejl ved hentning af roller',
      userListError: 'Fejl ved hentning af brugerliste',
      organisationListError: 'Fejl ved hentning af organisationsliste',
      loadingRoles: 'Indlæser roller...',
      selectRole: 'Vælg rolle',
      validEmail: 'Angiv en gyldig mailadresse',
      requiredEmail: 'E-mail er påkrævet',
      resend: 'Send igen',
      restrictedDomain: 'Restricted email domain',
      addUserSuccess: 'Bruger blev tilføjet',
      editUserSuccess: 'Bruger blev redigeret',
      deleteUserSuccess: 'Bruger blev slettet',
      deleteModalAlertMessage:
        'Du er ved at slette brugeren {{userName}}. Alle tilladelser for brugeren vil blive tilbagekaldt.',
      deleteProceedMessage: 'Vil du fortsætte med sletningen?',
      userAlreadyExist: 'Bruger findes allerede med dette mail-id.',
      addUserError: 'Bruger kunne ikke tilføjes. Prøv igen.',
      editUserError: 'Bruger kunne ikke redigeres. Prøv igen.',
      deleteUserError: 'Kunne ikke slette bruger. Prøv igen.',
      nodesError: 'Fejl ved hentning af tildelte noder',
      childNodesError: 'Fejl ved indlæsning af underordnede noder',
      hierarchyError: 'Fejl ved hentning af hierarki',
      requestFailed: 'Anmodningen mislykkedes',
      emailSentSuccess: 'E-mail om aktivering er sendt.',
      activationEmailError: 'Aktiveringsmail kunne ikke sendes.',
      activationEmailError1:
        'Aktiveringsmail kunne ikke sendes. Prøv igen senere.',
      allOrganisations: 'Alle organisationer',
      address: 'Adresse',
      hierarchyMetaError: 'Fejl ved hentning af hierarkioplysninger',
      nodeMetaError: 'Fejl ved indlæsning af nodeoplysninger',
      contactName: 'Kontaktnavn',
      downloadTemplate: 'Download skabelon',
      newOrg: 'Ny organisation',
      save: 'gem',
      upload: 'upload',
      uploading: 'Uploader',
      dropExcel: 'Placer Excel-ark, eller',
      browse: 'gennemse',
      importSettings: 'Importindstillinger',
      addNodesSites: 'Tilføj nye noder/steder',
      updateNodesSites: 'Opdater oplysninger for eksisterende noder/steder',
      disableNodesSites: 'Deaktiver noder/steder, der ikke længere findes',
      disabled: 'Deaktiveret',
      new: 'Ny',
      updated: 'Opdateret',
      siteInstallation: 'Steder',
      addOrgSuccess: 'Organisation oprettet med succes!',
      excelUploadError: 'Excel-ark kunne ikke gemmes. Prøv igen.',
      saveError: 'Lagring mislykkedes. Prøv igen senere.',
      saveBadRequestError:
        'Kunne ikke gemme. Dette er sandsynligvis et problem med de data, du forsøgte at gemme.',
      telephone: 'telefon',
      externalIds: "eksterne id'er",
      contactEmail: 'Kontakt Email',
      longitude: 'Længdegrad',
      latitude: 'Breddegrad',
      primaryContactName: 'navn på primær kontakt',
      primaryContactEmail: 'E-mail til primær kontakt',
      templateError: 'Fejl ved download af skabelon. Prøv igen senere',
      templateError1: 'Skabelon kan ikke hentes. Prøv igen senere',
      home: 'Hjem',
      organisations: 'Organisationer',
      users: 'Brugere',
      lightTheme: 'Lyst tema',
      darkTheme: 'Mørkt tema',
      login: 'Login',
      logout: 'Log ud',
      activateUserAcc: 'Aktivér brugerkonto',
      phoneNumber: 'Telefonnummer',
      optional: 'valgfri',
      password: 'Adgangskode',
      confirmPassword: 'Bekræft adgangskode',
      endUser: 'Slutbrugerlicensaftale',
      iAccept: 'Jeg accepterer slutbrugerlicensaftalen',
      iHereby: 'Jeg bekræfter hermed, at jeg har læst og accepteret',
      eula: 'Slutbrugerlicensaftale',
      iRead: 'Jeg har læst Honeywells persondatapolitik',
      iUnderstood: 'Ja, jeg har læst og forstået',
      privacyPolicy: 'Privatlivspolitik',
      activate: 'aktivér',
      activationSuccess: 'Aktivering lykkedes',
      newAccAccess:
        'Log ind med dit nye brugernavn for at få adgang til din nye konto. Det nye brugernavn vises nedenfor:',
      emailSent: 'Nyt brugernavn er sendt til dit mail-id.',
      signin: 'LOG IND',
      activationError: 'Aktivering mislykkedes',
      pleaseTryAgain: 'Prøv igen',
      activationExpired: 'Aktiveringstoken er udløbet',
      activationExpiredText:
        'Dette kan skyldes, at maillinket er udløbet, allerede er brugt eller er forkert. Anmode om en ny aktiveringsmail, hvis problemet fortsætter.',
      contactSupport: 'Fejl. Kontakt support',
      pwdMatch: 'Adgangskoderne skal være ens',
      required: 'Påkrævet',
      eligiblePwd:
        'Adgangskoden skal indeholde mindst 1 stort bogstav, 1 lille bogstav, 1 ciffer, 1 specialtegn og mindst 11 tegn',
      invalidPhoneNumber: 'Telefonnummeret er ugyldigt',
      invalidName:
        'Navnet må ikke overstige 255 tegn uden foran- eller efterstillede mellemrum',
      invalidFirstName: 'FirstName contains invalid characters.',
      invalidLastName: 'LastName contains invalid characters.',
      timezone: 'tidszone',
      timeZone: 'tidszone',
      commissioningStatus: 'ibrugtagningsstatus',
      countryCode: 'landekode',
      childCount: 'antal underordnede',
      sheetVersion: 'Version af regneark',
      unknownError: 'Ukendt fejl. Prøv igen senere.',
      preview: 'forhåndsvisning',
      file: 'Fil',
      inCompatibleExcel: 'Filen skal være i .xlsx-format.',
      selectOrg: 'Vælg organisation',
      noRecordFound: 'Der blev ikke fundet nogen poster',
      total: 'Samlet',
      items: 'Elementer',
      forbidden: 'Forbudt',
      noPermissionText:
        'Du har ikke tilladelse til at få adgang til denne side',
      accessPermission: 'Log på en konto med adgangstilladelser',
      technicianExternalAccessPermission: 'Log ind på mobilapplikationen.',
      redirectToLogin: 'Omdirigerer til logonside',
      errorUserSettings: 'Fejl under hentning af brugerindstillinger',
      invalidSystemGuid: 'ugyldigt System-GUID',
      languageNotSupported: 'Sproget understøttes ikke',
      subscriptions: 'Abonnementer',
      gatewayManagement: 'Gatewaystyring',
      subscriptionNumber: 'Abonnementsnummer',
      orderNumber: 'Ordrenummer',
      bundle: 'Bundt',
      activatedOn: 'aktiveringsdato',
      order: 'bestille',
      editSubscription: 'Rediger abonnement',
      noNodeSelected: 'Ingen node valgt',
      noUserSelected: 'Ingen bruger valgt',
      loadingBundles: 'Indlæser bundter...',
      bundlesError: 'Fejl ved hentning af bundter',
      selectBundle: 'Vælg bundt',
      addSubscriptionSuccess: 'Abonnement tilføjet',
      addSubscriptionError: 'Abonnement kunne ikke tilføjes. Prøv igen.',
      subscriptionInputValidationError:
        'kan være en alfanumerisk værdi med en bindestreg og må ikke overstige 13 tegn',
      errorUserGlobalPrivileges:
        'Fejl ved hentning af brugernes globale rettigheder',
      subscriptionAlreadyExist: 'Abonnement findes allerede.',
      invalidSubscription: 'Ugyldigt abonnement',
      Version: 'Version',
      systemType: 'Systemtype',
      systemId: 'System-id',
      reviewGatewayDetails: 'Gennemgå gateway detaljer',
      site: 'Sted',
      Organisation: 'Organisation',
      gatewayRegistration: 'Gateway registrering',
      selectAnOrg: 'Vælg en Org',
      selectASite: 'Vælg et sted',
      register: 'Registrer',
      selectSiteToRegsiter: 'Vælg websted for at registrere gatewayen',
      gatewayRegistrationFailureMsg:
        'Kunne ikke registrere gatewayen med Honeywell Sentience IOT-platformen',
      gatewayRegistrationSuccessMsg:
        'Gateway er blevet registreret med Honeywell Sentience IOT-platformen',
      siteEmptyMsg:
        'Alle websteder for organisationen {{- orgName}} er allerede registreret',
      forgeOnboarding: 'Organisationstilknytning',
      SiteFetchingFailure: 'Der kunne ikke hentes steder fra Forge',
      selectAllSitesText:
        'Vælg alle forfalskede steder der skal indbygges på Remote Building Manager',
      onBoardingFailure: 'Registrering af sted kunne ikke startes',
      customerID: 'Kunde-id',
      enterCustomerID: 'Angiv kunde-id',
      loadingSites: 'Indlæser steder...',
      fetchSites: 'HENT STEDER',
      subscriptionActivateSuccess: 'Abonnement på "{{siteName}}" er aktiveret',
      subscriptionActivateError:
        'Kan ikke aktiveres på grund af et teknisk problem. Kontakt venligst din administrator',
      activateNow: 'Aktiver nu',
      multiSiteSuccess: 'Steder er tilføjet.',
      onboardSelected: 'Onboard valgte',
      sitePartialSuccess:
        'Nogle steder kunne ikke onboardes på grund af et teknisk problem. Prøv igen, eller kontakt din administrator.',
      confirm: 'Bekræft',
      onboardingFailed: 'Onboarding mislykkedes',
      failed: 'Mislykkedes',
      onboardedSuccessfully: 'Stedet er onboardet',
      notOnboarded: 'Ikke onboardet',
      onboarding: 'Onboardes...',
      reOnboard: 'Onboard igen',
      selectAll: 'Vælg alle',
      siteSuccess: 'Stedet blev tilføjet.',
      dataloseWarning: 'Opdater ikke siden, mens steder onboardes.',
      addServiceSuccess: 'Tjenester blev tilføjet',
      addServicesText: 'Tilføj tjenester',
      validityText: 'Gyldighedsperiode',
      invalidInputError: 'ugyldigt input',
      subsactivateError: 'Abonnement allerede aktiveret',
      subsnotfoundError: 'Abonnementsoplysninger ikke fundet',
      invalidorderError: 'Ugyldigt ordrenummer',
      bundnotfoundError: 'Bundle detaljer ikke fundet',
      subscribedServices: 'ABONNERET TJENESTER',
      subsactivateSuccess: 'Abonnementet er oprettet og aktiveret',
      subsactivateFailure:
        'Abonnement oprettet, men aktivering mislykkedes. Prøv igen !!',
      subsactivateDiffSite:
        'Abonnement allerede aktiveret for et andet websted',
      gatewayAssociation: 'Gateway-tilknytning',
      systemGuid: 'System-GUID',
      success: 'Udført',
      contactSystemAdministrator: 'Kontakt venligst din systemadministrator',
      siteName: 'Navn på sted',
      location: 'Beliggenhed',
      action: 'Handling',
      addNewSite: 'Tilføj nyt websted',
      add: 'Tilføj',
      sitesAssociated: '{{siteCount}} Tilknyttede websteder',
      numberOfAddon: 'Number of Addon',
      searchSite: 'Søg efter steder',
      noResultFound: 'Ingen resultater fundet',
      noDataFound: 'Ingen data fundet',
      loadMore: 'Indlæs mere',
      unlinkMessage:
        'For at ophæve {{siteName}} fra {{sku}} skal du kontakte Honeywells kundeservicecenter (+01 480-353-3020) eller sende en e-mail til support@honeywell.com',
      associatedOrderNumber: 'Tilknyttet ordrenummer',
      associatedSubscriptionNumber: 'Tilknyttet abonnementsnummer',
      helperTextSKU: 'Hvis du vil ændre abonnementsnummeret, skal du kontakte',
      helperOrderTextSKU: 'Hvis du vil ændre ordrenummeret, skal du kontakte',
      customerCare: 'Kundeservice',
      skuDetails: 'SKU detaljer',
      manageSites: 'Administrer websteder',
      skuName: 'SKU navn',
      skuDescription: 'SKU Beskrivelse',
      licenseUtilization: 'Licensudnyttelse',
      validTill: 'Gyldig til',
      editSKU: 'Rediger SKU',
      duplicateSiteError: 'Siden er allerede tilføjet',
      numberOfAddonRequired: 'Please enter Number of Addon',
      siteFetchError: 'Fejl ved hentning af webstedsliste',
      siteSuccessMsg: 'Websteder blev tilføjet',
      siteFailedMsg: 'Websteder kunne ikke tilføjes',
      problemWithRequest: 'There was a problem with the request.',
      newSubscriptionAdded: 'Nyt abonnement tilføjet',
      licensesOf: 'Licenser af',
      all: 'Alle',
      orderPlacedBy: 'Ordre placeret af',
      pendingRenewal: 'Afventer fornyelse',
      daysRemaining: 'Dage tilbage',
      renewSubscriptionMessage:
        'At forny {{skuName}} skal du kontakte Honeywells kundeservicecenter (+01 480-353-3020) eller sende en e-mail til support@honeywell.com',
      columnSelection: 'Valg af Kolonne',
      selectUpTo: 'Du kan vælge op til',
      itemsToDisplay: 'elementer, der skal vises i tabellen.',
      subscriptionManagement: 'Administration af abonnementer',
      activated: 'Aktiveret',
      warningHeader: 'Er du sikker på, at du vil annullere?',
      warningMessage: 'Der er ikke-gemte ændringer, som går tabt',
      renewSubscription: 'Forny abonnement',
      pendingActivation: 'Afventer aktivering',
      notAuthorizedError:
        'Du er ikke autoriseret til at tildele SKU til denne organisation',
      gatewayRegistrationInProgress: '{{gateway}} i gang',
      gatewayAssociationFailed:
        'Kontroller venligst gateway-forbindelsen og prøv igen. Hvis det mislykkes igen, kontakt venligst din systemadministrator.',
      gatewayRegistrationFailed:
        'Prøv igen. Hvis det mislykkes igen, kontakt venligst din systemadministrator.',
      doAssociationMessage:
        'Please check gateway connectivity and proceed with gateway association.',
      errorInAssociation: 'Fejl i behandlingen af tilknytningen.',
      association: 'Tilknytning',
      dataloseWarningForRegistration:
        'Gateway-registrering er i gang. Det kan tage et par minutter. For at undgå tab af data skal du ikke opdatere.',
      dataloseWarningForAssociation:
        'Gatewaytilknytning er i gang. Det kan tage et par minutter. For at undgå tab af data skal du ikke opdatere.',
      objectName: 'Object Name',
      objectType: 'Object Type',
      unitName: 'Enhed',
      bitunpack: 'Bit Unpack',
      bitRange: 'Bit Range',
      propName: 'Prop Name',
      propDataType: 'Data Type',
      propValue: 'Prop Value',
      msgType: 'MESSAGE TYPE',
      isMultiState: 'Is Multi State',
      scalingOperation: 'Scaling Operation',
      scalingFactor: 'Scaling Factor',
      byteOrder: 'Byte Order',
      propertyName: 'Property Name',
      addTemplateSuccess: 'Skabelon tilføjet med succes',
      addTemplateError: 'Kunne ikke tilføje skabelon.Prøv igen.',
      updateTemplateSuccess: 'Skabelon opdateret med succes',
      updateTemplateError: 'Kunne ikke opdatere skabelonen.Prøv igen.',
      outOfRangeError: 'Værdi skal være mellem {{min}} og {{max}}',
      requiredField: 'Udfyld venligst alle felt (r)',
      templateName: 'Skabelonnavn',
      modelName: 'Modelnavn',
      vendorName: 'Leverandørnavn',
      uniqueValueError: 'Værdi skal være unik',
      templateMangement: 'Skabelonstyring',
      equipmentType: 'Udstyrstype',
      selectType: 'Vælg Type',
      listOfTemplate: 'Liste over skabelon',
      selectTemplate: 'Vælg skabelon',
      ElectricityVoltage: 'Elektricitetsspænding',
      ElectricityCurrent: 'Elektricitetsstrøm',
      ElectricPowerFactor: 'Elektrisk effektfaktor',
      ElectricFrequency: 'Elektrisk frekvens',
      EnergyReceived: 'Modtaget energi',
      ActivePower: 'Aktiv kraft',
      ActivePowerA: 'Aktiv strøm A',
      ActivePowerB: 'Aktiv effekt B',
      ActivePowerC: 'Aktiv effekt C',
      ReactivePower: 'Reaktiv kraft',
      ApparentPower: 'Tilsyneladende magt',
      PeakDemand: 'Højeste efterspørgsel',
      ElectricityCurrentA: 'Elektricitetsstrøm A',
      ElectricityCurrentB: 'Elektricitetsstrøm B',
      ElectricityCurrentC: 'Elektricitetsstrøm C',
      ElectricityVoltageA: 'Elektricitetsspænding A',
      ElectricityVoltageB: 'Elektricitetsspænding B',
      ElectricityVoltageC: 'Elektricitetsspænding C',
      ElectricityConsumption: 'Elektricitetsforbrug',
      loaderWelcomeMessage:
        'Velkommen til Onboarding-portalen. Vent et øjeblik.',
      latitudeAndLongitude: 'Breddegrad & Længde',
      siteUpdateSuccessMessage: 'Stedoplysninger er opdateret',
      siteUpdateErrorMessage: 'Fejl under opdatering af steddetaljer',
      provisioningFailedMessages: 'Klargøring af sted mislykkedes. Prøv igen',
      onboardAllSites: 'Onboard alle steder',
      geoCordinatesErrorMsg: 'Kontrollér koordinaterne',
      tooltipCordinateMessage: 'koordinaterne skal være mellem',
      emptyValueMessage: 'Tom værdi er ikke tilladt',

      browseFile: 'Browse File',
      fileTypeErrorMsg: 'File type is not allowed',

      orgImgTitle: 'Upload Organization Logo',
      orgImgDropTxt: 'Drag and Drop Logo',
      orgImgInfoTxt:
        'W {{width}}px X H {{height}}px and Only *.png file format',
      orgImgPreviewTxt: 'Preview Logo',
      orgImgTooltipTxt:
        'Logo to have transparent background and should contrast black header background',
      orgImgSizeOfErrorMsg:
        'Image size should be max width {{width}}px, max height {{height}}px, minimum width {{minWidth}}px, minimum height {{minHeight}}px and max size {{maxSize}}kb',

      siteImgTitle: 'Upload Site image',
      siteImgDropTxt: 'Drag and Drop Building image (*.png or .jpg)',
      siteImgPreviewTxt: 'Preview Site Details Page',
      siteTooltipTxt:
        'Image will be cropped 46px on right & left and 30px on top & bottom part of the image based on different monitor resolution',
      siteImgInfoTxt:
        'W {{width}}px X H {{height}}px and *.png & *.jpg file format',
      siteImgSizeOfErrorMsg:
        'Image size should be max width {{width}}px, height {{height}}px and size {{maxSize}}kb',
      orTxt: 'Or',
      addLogo: 'Add Logo',
      addImage: 'Add Image',
      imageUploadSuccess: 'Image Uploaded Successfully',
      alertnteId: 'Alternativt brugernavn:',
      username: 'brugernavn:',
      errorFetchingUser: 'Fejl ved hentning af brugeroplysninger',
      errorFetchingRoles: 'Fejl ved hentning af roller',

      gateway: 'GATEWAY',
      associateAndSyncBtn: 'ASSOCIERE & SYNKRONISERE',
      cancelBtn: 'ANNULLER',
      guidValidationError: 'GUID-valideringsfejl',
      gatewayId: 'GATEWAY-ID',
      addNewGateway: 'Tilføj ny gateway',
      successMessage1: 'Forbindelse af webstedet, fuldført',
      successMessage2:
        'Forbindelse af webstedet, fuldført. Model synkronisering vil blive påbegyndt',
      errorMessage:
        'Forbindelse mislykkedes, modelsynkronisering vil ikke blive påbegyndt',
      importUsers: 'Importer brugere',
      importUsersSubHeading:
        'Tilføj og administrer, hvad du vil importere ved at downloade CSV-skabelonen.',
      dropCsvHere: 'Træk og slip fil her eller',
      browsrForFiles: 'Gennemse filer',
      subHeadingBrowser:
        'Kun CSV-filer accepteres, og filen må ikke overstige 5 MB.',
      subHeadingBrowserTwo: '(kun én upload mulig ad gangen)',
      userUploadSuccess: 'Successfully data sent',
      userUploadProcessing:
        'The data has been successfully uploaded. We are currently processing and will take a few minutes. We will update you soon.',
      fileNameDisplay: 'File Name :',
      fileName: 'File Name',
      errorNotification:
        'We encountered an issue while uploading the template, please rectify below errors and re-upload the template.',
      errorHeading: 'Fejl',
      slnumber: 'SL NO.',
      errorMessageHeading: 'ERROR MESSAGE',
      endUserAgreement: 'Vilkår for Honeywell Forge',
      privacyStatement: 'Privatlivserklæring',
      yourPrivacyChoices: 'Dine valg for beskyttelse af personlige oplysninger',
      cookieNotice: 'Cookie-meddelelse',
      dataCentre: 'Datacenter',
      isForgeText: 'Bygninger',
      gatewayIdleMessage:
        'Du har været inaktiv i nogle minutter, opdater venligst siden for at fortsætte',
      refresh: 'Opdater',
      landingLogin: 'Klik her',
      loginUserIntegratorRole: 'BA e-commerce brugere',
      loginUserCustomerRole: 'Alle andre brugere',
      loginWelcomeNote:
        'Velkommen, vælg venligst din rolle nedenfor for at komme i gang.',
      termsAndConditions: 'Vilkår og betingelser',
      accept: 'Accepter',
      legalPatentInformation: 'Juridiske patentoplysninger',
      onboardingPortal: 'Onboardingportal',
      customers: 'Kunder',
      templates: 'Skabeloner',
      assetModelling: 'Modellering af aktiver',
      selectCustomer: 'Vælg kunde',
      integration: 'Integration',
      integrationSubtitle: 'Integrer sømløst for indsigt i ydeevne i realtid',
      customer: 'Kunde',
      accessibleCustomersError: 'Fejl under hentning af tilgængelige kunder',
      workflows: 'Arbejdsgange (Legacy)',
      apiCredentials: 'API-legitimationsoplysninger',
      integrationsTab: 'Arbejdsgange',
      noSubscription:
        'Intet aktivt abonnement fundet. Tegn abonnement for at få adgang til denne funktion.',
      loading: 'Indlæser...',
      licenseManagement: 'Licensstyring',
      activityLogTitle: 'Aktivitetslogs',
      activityLogSubtitle:
        'Spor workflow-hændelser og statusopdateringer på tværs af udvalgte kunder',
      activityLogSidebarTitle: 'Aktivitetslogs',
      activityLogSidebarSubtitle:
        'Her er aktivitetsdata for alle dine kundeorganisationer',
      activityLogListTitle: 'Liste over aktiviteter',
      activityLogSearchPlaceholder: 'Søg efter aktivitet, sted',
      activityLogLastUpdated: 'Sidst opdateret',
      activityLogCreatedOn: 'Oprettet den',
      activityLogActivity: 'Aktivitet',
      activityLogSite: 'Sted',
      activityLogStatus: 'Status',
      activityLogCreatedBy: 'Oprettet af',
      activityLogUpdatedBy: 'Opdateret af',
      activityLogNameUnavailable: 'Navn ikke tilgængeligt',
      activityLogUserNamesError:
        'Kunne ikke indlæse OprettetAf-/OpdateretAf-navne',
      activityLogStatusSuccess: 'Udført',
      activityLogStatusFailed: 'Mislykkedes',
      activityLogStatusInProgress: 'I gang',
      activityLogStatusQueued: 'Sat i kø',
      activityLogStatusPending: 'Venter',
      activityLogStatusSkipped: 'Sprunget over',
      activityLogPaginationInfo:
        '{startItem} - {endItem} af {totalItems} elementer',
      activityLogPageGoTo: 'Gå til side',
      activityLogRowPerPage: 'Rækker pr. side',
      activityLogRetry: 'Prøv igen',
      activityLogRetrying: 'Prøver igen...',
      activityLogRetrySuccess: 'Genforsøg af opgave blev startet.',
      activityLogRetryError: 'Kunne ikke forsøge opgaven igen. Prøv igen.',
      activityLogRetryAllSuccess: 'Alle opgaver blev forsøgt igen med succes.',
      activityLogRetryAllFailed:
        'Alle forsøg på genoptagelse mislykkedes. Prøv venligst igen.',
      activityLogRetryPartialFailed:
        'Nogle opgaver kunne ikke forsøges igen. Prøv igen.',
      activityLogLoading: 'Indlæser detaljer...',
      activityLogFetchError:
        'Kunne ikke indlæse aktivitetsdata. Prøv venligst igen.',
      activityLogModalClose: 'Luk',
      activityLogModalTasks: 'Opgaver',
      activityLogModalCreatedOn: 'Oprettet den',
      activityLogModalLastUpdatedOn: 'Sidst opdateret den',
      activityLogModalSupportNote:
        'Beskrivelse af fejlhændelsen og årsagskoden.',
      activityLogModalSupportReach: 'Kontakt for hjælp',
      activityLogModalSupportEmail: 'connectedbuildingsupport@honeywell.com',
      activityLogFilterTitle: 'Filtrer efter',
      noCustomersAvailable: 'Ingen kunder til rådighed',
      activityLogFilterStatus: 'Status',
      activityLogFilterActivity: 'Aktivitet',
      activityLogFilterSite: 'Sted',
      activityLogFilterCreatedBy: 'Oprettet af',
      activityLogFilterApply: 'Anvend',
      activityLogFilterReset: 'Nulstil',
      activityLogFilterNoOptions: 'Ingen tilgængelige indstillinger',
      activityLogFilterError:
        'Kunne ikke indlæse filtermuligheder. Prøv venligst igen.',
      search: 'Søg',
      more: 'mere',
      noResults: 'Ingen resultater fundet',
      activityLogCustomizeColumns: 'Tilpas kolonner',
      activityLogColumnsReorder: 'Genbestil',
      activityLogColumnsAddRemove: 'Tilføj/Fjern',
      activityLogColumnsReorderDescription:
        'Omplacering for at ændre rækkefølgen af kolonner i tabellen',
      activityLogColumnsAddRemoveDescription:
        'Marker kolonner for at vise dem i tabellen',
      activityLogDetails: 'Detaljer',
      activityLogFiltersChanged:
        'Der blev ikke fundet data for de valgte filtre. Juster eller nulstil dine filtre for at se resultater.',
      activityLogResetFilters: 'Nulstil filtre',
      activityLogSiteState: 'Tilstand',
      activityLogSiteCity: 'By',
      workflowTaskCBCustomerCreation: 'CB kundeoprettelse',
      workflowTaskOnboardingStatusUpdatePartnerPortal:
        'Opdatering af onboarding-status i partnerportalen',
      workflowTaskUpdateCBCustomerIdPartnerPortal:
        'Opdater CB-kunde-id i partnerportalen',
      workflowTaskEOMCustomerCreation: 'Oprettelse af EOM-kunde',
      workflowTaskOnboardCustomerForAI: 'Onboarding af kunde til AI',
      workflowTaskDeleteCustomerInCBPortal: 'Slet kunde i CB-portalen',
      workflowTaskUpdateCustomerInCBPortal: 'Opdater kunde i CB-portalen',
      workflowTaskUpdateCustomerInEOM: 'Opdater kunde i EOM',
      workflowTaskUpdateCustomerInAssetModelling:
        'Opdater kunde i aktivmodellering',
      workflowTaskTrackScanStatusFileAttachment:
        'Spor scanningsstatus for filvedhæftning',
      workflowTaskCBSiteCreation: 'Oprettelse af CB-sted',
      workflowTaskUpdateCBSiteIdPartnerPortal:
        'Opdater CB-sted i partnerportalen',
      workflowTaskEOMSiteCreation: 'Oprettelse af EOM-sted',
      workflowTaskUpdateEOMSiteIdPartnerPortal:
        'Opdater EOM-sted-id i partnerportalen',
      workflowTaskSyncExistingUsersCBPortal:
        'Synkroniser eksisterende brugere til CB Portal',
      workflowTaskUpdateUserSyncStatusPartnerPortal:
        'Opdatering af brugersynkroniseringsstatus i partnerportalen',
      workflowTaskCalculateEnergySavingsPotential:
        'Beregn energibesparelsespotentiale',
      workflowTaskDeleteSiteInCBPortal: 'Slet sted i CB-portalen',
      workflowTaskDeleteSiteInEOM: 'Slet sted i EOM',
      workflowTaskUpdateSiteInCBPortal: 'Opdater sted i CB-portalen',
      workflowTaskUpdateSiteInEOM: 'Opdater sted i EOM',
      workflowTaskUpdateSiteInAssetModelling:
        'Opdater sted i inventarmodellering',
      workflowTaskUpdateSiteInFindAPI: 'Opdater sted i Find API',
      workflowTaskSyncSubscriptionAssociationCBPortal:
        'Synkroniser abonnementsassociation til CB-portalen',
      workflowTaskEnableBrickOntology: 'Aktiver Brick-ontologi',
      workflowTaskOnboardCustomerForgeAPI: 'Onboarding af kunde til ForgeAPI',
      workflowTaskPublishForgeAPIOnboardingStatus:
        'Publicer ForgeAPI onboardingstatus til Håndtering af legitimeringer',
      workflowTaskAddUserInCBPortal: 'Tilføj bruger i CB-portalen',
      workflowTaskUpdateUserProvisioningStatus:
        'Opdater brugerens klargøringsstatus',
      workflowTaskDeleteUserInCBPortal: 'Slet bruger i CB-portalen',
      workflowTaskUpdateUserDeletionStatus: 'Opdater status for brugersletning',
      workflowCustomerCreation: 'Oprettelse af kunde',
      workflowCustomerDelete: 'Sletning af kunde',
      workflowCustomerUpdate: 'Opdatering af kunde',
      workflowFileAttachmentsScan: 'Scanningsstatus vedhæftede filer',
      workflowSiteCreation: 'Oprettelse af sted',
      workflowSiteDelete: 'Sletning af sted',
      workflowSiteUpdate: 'Opdatering af sted',
      workflowSubscriptionAssociation: 'Abonnementstilknytning',
      workflowAddUser: 'Tilføj bruger',
      workflowDeleteUser: 'Sletning af bruger',
      workflowNamePlate: 'Navneplade',
      workflowForgeAPIOnboarding: 'Forge API-onboarding',
      workflowAddUserMultiple: 'Arbejdsgang til tilføjelse af flere brugere',
      workflowDeleteUserMultiple: 'Arbejdsgang til sletning af flere brugere',
      workflowModelFileUpload: 'Modelfil-upload',
      workflowGatewayAssociation: 'Gateway-tilknytning',
      workflowIntegrationRegistered: 'Integration registreret',
      workflowTaskForgeAPIOnboardingStatus: 'Status for Forge API-onboarding',
      workflowTaskAddUser: 'Arbejdsgang til tilføjelse af bruger',
      workflowTaskProcessModelFile: 'Behandl modelfil',
      workflowTaskNotifyAssetModelling: 'Underret om modellering af aktiver',
      workflowTaskAssociateGateway: 'Tilknyt gateway til site',
      workflowTaskFetchModelToAssetModelling: 'Hent model til aktivmodellering',
      workflowTaskNameProcessNamePlate: 'Behandl navnepladefil',
      workflowTaskUpdateModelInFindAPI: 'Opdater model i Find API',
      workflowTaskProcessIntegrationRegistered:
        'Behandl registreret integration',
      workflowTaskProcessDFNotificationIntegrationRegistered:
        'Behandl DF-meddelelse om registreret integration',
      workflowTaskTenantOnboardingAFO: 'Onboarding af lejere til AFO',
      workflowTaskOnboardCustomerCDL: 'Onboarding af kunde til CDL',
      workflowTaskPublishAFOOnboardingStatus: 'Publicer AFO-onboardingstatus til Rule Builder-tjenesten',
      activityLogCorrelationId: 'Korrelations-id',
      activityLogTaskId: 'Opgave-id',
      activityLogToastSuccess: 'Udført',
      activityLogToastError: 'Fejl',
      activityLogIteration: 'Iteration',
      activityLogFieldFirstName: 'Fornavn',
      activityLogFieldLastName: 'Efternavn',
      activityLogFieldSubscriptionName: 'Abonnementsnavn',
      activityLogFieldName: 'Navn',
      activityLogFieldCurrency: 'Valuta',
      activityLogFieldZip: 'Postnummer',
      activityLogFieldArea: 'Område',
      activityLogFieldCity: 'By',
      activityLogFieldState: 'Tilstand',
      activityLogFieldCountry: 'Land',
      activityLogFieldAreaUnit: 'Områdeenhed',
      activityLogFieldLanguage: 'Sprog',
      activityLogFieldLatitude: 'Breddegrad',
      activityLogFieldSiteType: 'Stedtype',
      activityLogFieldTimezone: 'Tidszone',
      activityLogFieldLongitude: 'Længdegrad',
      activityLogFieldCountryCode: 'Landekode',
      activityLogFieldSiteId: 'Sted-id',
      activityLogFieldFileType: 'Filtype',
      activityLogFieldReason: 'Årsag',
      activityLogFieldCustomerSupportEmails: 'E-mailadresser til kundesupport',
      activityLogFieldAddressLine1: 'Adresselinje 1',
      activityLogFieldAddressLine2: 'Adresselinje 2',
      activityLogFieldContactEmail: 'Kontakt-e-mail',
      activityLogSiTitle: 'Aktivitetslog',
      support: 'Support',
      projectManagement: 'Projektstyring'
    }
  }
};
